import type {
  ApplicationDocumentTypeEnum,
  OrganizationDocumentTypeEnum,
} from '@acme/api';

export type DocumentDatePeriod = 'all' | '7d' | '30d';

export type ApplicationDocumentsFiltersValue = {
  search: string;
  documentTypeId?: ApplicationDocumentTypeEnum;
  period: DocumentDatePeriod;
};

export type OrganizationDocumentsFiltersValue = {
  documentTypeId?: OrganizationDocumentTypeEnum;
  period: DocumentDatePeriod;
};

export function getDocumentDateRange(period: DocumentDatePeriod): {
  dateFrom?: string;
  dateTo?: string;
} {
  if (period === 'all') return {};
  const now = new Date();
  const days = period === '7d' ? 7 : 30;
  const from = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
  return {
    dateFrom: from.toISOString(),
    dateTo: now.toISOString(),
  };
}
